<div class="header-logo">
    <img *ngIf="dealerInfo" [src]="dealerInfo.logo && dealerInfo.logo !== '' ? dealerInfo.logo : 'assets/images/logo-wide.png'">
</div>
<div class="header-content"><ng-content select="[content]"></ng-content></div>
<div class="header-account"><ng-content select="[account]"></ng-content></div>
